<template src="./index.html"></template>
<script>
import { getdata } from './data.js';
import uploadFileplus from '../../../common/uploadFileplus/index.vue';
import FileToSeeplus from '../../../common/FileToSeeplus/index.vue';
import SalesTaxReport from './SalesTaxReport/index.vue';
import AssetsAndLiabilitiesY from './AssetsAndLiabilitiesY/index.vue';
import AssetsAndLiabilities from './AssetsAndLiabilities/index.vue';
import SmallScaleVAT from './SmallScaleVAT/index.vue';
import valueAddedTax from './valueAddedTax/index.vue';
import corporateIncomeTax from './corporateIncomeTax/index.vue';
import corporateIncomeTax_V2 from './corporateIncomeTax_V2/index.vue';
import ConsolidatedStatement from './ConsolidatedStatement/index.vue';
import TaxableService from './TaxableService/index.vue';
import DisabilityPayment from './DisabilityPayment/index.vue';
import GeneralReturn from './GeneralReturn/index.vue';
import GeneralReturnF from './GeneralReturnF/index.vue'
import BalanceSheet from './BalanceSheet/index.vue';
import AdditionalTax from './AdditionalTax/index.vue';
import shpz from '../../AuditCenter/shpz/index.vue';
import splc from '../../AuditCenter/splc/index.vue'
import {
	login,
	manuscriptquery,
	manuscriptUploadFile,
	annexadd,
	queryAttachmentList,
	annexdelete,
	forShengcdg,
	submitAudit,
	manuscriptexport,
	manuscriptcancelAudit,
	manuscriptrole,
	queryCompanyList,
	addyhsTime,
	delete_yhsReport,
    queryCompanyShuibDict,
	calculateByReportRisk,
	queryRiskDetail ,
	auditFlow,
    manuscriptconfirmTheReview,
} from '../../../../api/Draftgeneration.js';
import {getShuizList, templateExquery} from '../../../../api/bbmb.js';
import {fxjk_getPolicyInfo} from '../../../../api/Notificationsettings.js'
import { dgsh_getCommentsByIds } from '../../../../api/dgsh.js';
import config from '../../../../../configHttp.js';
export default {
	name: 'Draftgeneration',
	components: {
		shpz,
		uploadFileplus,
		FileToSeeplus,
		SalesTaxReport,
		AssetsAndLiabilitiesY,
		AssetsAndLiabilities,
		SmallScaleVAT,
		valueAddedTax,
		corporateIncomeTax,
    corporateIncomeTax_V2,
		ConsolidatedStatement,
		BalanceSheet,
		DisabilityPayment,
		TaxableService,
		GeneralReturn,
		splc,
	GeneralReturnF,
	AdditionalTax

	},
	data: function() {
		return {
			//页面查询
			remarkShow:false,
			idList:[],
			searchdata: getdata().searchdata,
			searchlist: getdata().searchlist,
			searchdiag: false,
			ApprovalProcess:false,
			outlist: [],
			remark:'',
			headData: getdata().headData,
			tableData: getdata().tableData,
			pagination: getdata().pagination,
			suosq: this.$getdefultMonth(),
			pagination_risk:getdata().pagination_risk,
			risk:{
				nsrmc:'',
				Declaration:'',
			},
			checked: false,
			Saleparams: {},
			//文件上传
			shaidiag: false,
			bbztsb:getdata().bbztsb,
			formlist: getdata().formlist,
			formdata: {
				type: '',
				name: '',
				description: ''
			},
			upfile: {},
			updiag: false,
			//附件查看
			toseediag: false,
			chooseid: '',
			choosecompanyCode: '',
			chooseshuibId: '',
			SaleObj: {},
			headseeData: getdata().headseeData,
			paginationfile: getdata().paginationfile,
			tableseeData: getdata().tableseeData,
			showbox: {
				hjbhs: false,
				yhs: false,
				zzs: false,
				cwbbybqyyzx: false,
				cwbbybqywzx: false,
				cwbbxqy: false,
				zzsxgm: false,
				qysdsA: false,
        qysdsA_V2: false,
				cztds: false,
				fcs:false,
				cwbbkjzd:false,
				cbj:false,
				whsy:false,
				tysl:false,
				tygh:false,
				tylj:false,
				ty:false,
				noty:false,
				xfs:false
			},
			mintext: '填写',
			fxdetail: false,
			headDatafx: getdata().headDatafx,
			tableDatafx: [],
			tablekey: 0,
			detailtype: '',
			seeNow: false,
			showsh: false,
			dataSources: {},
			differentiate: '',
			textarea: '',
			name: '',
			list:[],
			edit:false,
			long:0,
			overlength:0,
			//新增印花税次报
			secondaryReport:false,
			headDatasecondary:getdata().headDatasecondary,
			StampTaxList:[],
			//
			xinzhen: {
				id: '',
				select: {
					zbdlvalue: '',
					zbleb: '',
					yjvalue: '',
					number: ''
				},
				baocunzhancun: {
					shenbaozonglei: [],
					tianjiazhengc: []
				},
				radio: '1',
				zhibiaomincheng: '',
				shuzhi: {
					shuzhi: '',
					qujianqian: '',
					qujianho: ''
				},
				baifbi: {
					baifbiqian: '',
					baifbiho: ''
				},
				mx: {},
				duiyingchelue: '',
				calculationFormula:'',
				nowValue:'',
			},
			selectfxjk:false,
      // 模板列表
      templateDataMap: {},
      // 底稿生成、申报缴款页面是否显示 仅展示零申报企业条件
      lsbqyEnable: config.lsbqyEnable,
		};
	},
	created() {
		// login({"username":"admin","password":"123456"}).then(res=>{
		// 	localStorage.setItem("token",res.data.data)
		// })
		 if (config.company == 'mb') {
		            this.headData.splice(5,0,{
		                title: "工作底稿状态",
		                prop: "workManuscriptStatus",
		                width: "100",
		                align:"center",
		                custom: true,
		            });
		            this.searchlist.splice(2,0,{
		                prop: "cank4",
		                label: '企业分类',
		                type: "select",
		                selectval:[
		                    {label:"满满",value:"1"},
		                    {label:"帮帮",value:"2"}
		                ]
		            })
		        }
		this.searchlist.forEach(item=>{
			if(item.prop=='bbzt'){
				item.selectval = JSON.parse(JSON.stringify(this.bbztsb))
			}
		})
		this.searchlist = JSON.parse(JSON.stringify(this.searchlist))
		this.manuscriptquery();
    templateExquery({current: 1, size: 50}).then(res => {
      this.templateDataMap = res.data.data.records.reduce((map, item) => {
        map[item.id] = item;
        return map;
      }, {});
    })
	},
	activated() {
		this.manuscriptquery();
		
	},
	mounted() {

	},
	methods: {	
		//编辑 查看
		bianji(e) {
			let params = {
				id: e.id
			};
			this.xinzhen.id = e.id;
			fxjk_getPolicyInfo(params).then(res => {
				this.xinzhen.select.zbdlvalue = res.data.data.category;
				this.xinzhen.radio = res.data.data.enable;
		
				if (res.data.data.type != null) {
					this.xinzhen.select.zbleb = res.data.data.type.toString();
				}
				this.xinzhen.zhibiaomincheng = res.data.data.name;
				this.xinzhen.valveValue = res.data.data.valveValue;
		
				if (res.data.data.valueType != null) {
					this.xinzhen.select.yjvalue = res.data.data.valueType.toString();
				}
		
				if (res.data.data.valueJsType != null) {
					this.xinzhen.select.number = res.data.data.valueJsType.toString();
				}
				this.xinzhen.mx.yewkmCode = res.data.data.indexNo;
				this.xinzhen.mx.yewkmCodeyewkmName = res.data.data.manageModel;
				this.xinzhen.mx.description = res.data.data.modelDesc;
				this.xinzhen.baocunzhancun.shenbaozonglei = res.data.data.shuibList;
				this.xinzhen.baocunzhancun.tianjiazhengc = res.data.data.zcList;
				this.xinzhen.duiyingchelue = res.data.data.yidcl;
				this.xinzhen.nowValue = res.data.data.nowValue;
				this.xinzhen.calculationFormula = res.data.data.calculationFormula;
				if (res.data.data.valueType == 1) {
					this.xinzhen.baifbi.baifbiqian = res.data.data.valueStart;
					this.xinzhen.baifbi.baifbiho = res.data.data.valueEnd;
				} else {
					if (this.xinzhen.select.number > 2) {
						this.xinzhen.shuzhi.shuzhi = res.data.data.valueStart;
					} else {
						this.xinzhen.shuzhi.qujianqian = res.data.data.valueStart;
						this.xinzhen.shuzhi.qujianho = res.data.data.valueEnd;
					}
				}
				this.selectfxjk = true;
		
			});
		},
	  geOoverLength(e){
		  this.overlength = e;
	  },
		//风险计算
		RiskCalculation(e){
			let params = {
				id:e.id
			}
			calculateByReportRisk(params).then(res=>{
				 if(res.data.code==1){
					this.manuscriptquery();
				}else{
					this.$message.error(res.data.msg)
				}
			})
		},
		//风险详情
		RiskDetails(e){
			let params = {
				id:e.id,
				current:this.pagination_risk.pageNum,
				size:this.pagination_risk.pageSize,
			}
			queryRiskDetail(params).then(res=>{
				 if(res.data.code==1){
					 this.tableDatafx = res.data.data.records
					 this.pagination_risk.total = res.data.data.total
					 this.risk.nsrmc = e.nsrmc
					  this.risk.Declaration = e.sbzl
					this.fxdetail=true
				}else{
					this.$message,error(res.data.msg)
				}
			})
		},
		Lengthofmotion(){
			this.long=0
			 this.headData[8].width=0;
			for (var i = 0; i < this.tableData.length; i++) {
				if (
					this.tableData[i].status == '1' ||
					this.tableData[i].status == '4' ||
					this.tableData[i].status == '7' ||
					this.tableData[i].status == '8' ||
					this.tableData[i].status == '0' ||
					this.tableData[i].status == '-1'
				) {

					this.long=this.long+50;
					this.headData[8].width=this.long
					this.headData=JSON.parse(JSON.stringify(this.headData))
					break;
				}
			}
			for (var i = 0; i < this.tableData.length; i++) {
				if (this.tableData[i].status == '1' && this.showsh) {
					this.long=this.long+50;
					this.headData[8].width=this.long
					this.headData=JSON.parse(JSON.stringify(this.headData))
					break;
				}
			}
			for (var i = 0; i < this.tableData.length; i++) {
				if (this.tableData[i].status=='2'||this.tableData[i].status=='3') {
					this.long=this.long+70;
					this.headData[8].width=this.long
					this.headData=JSON.parse(JSON.stringify(this.headData))
					break;
				}
			}
		},
		postil(v, k) {
			this.dataSources = v;
			this.differentiate = k;
			let params = { id: this.dataSources.id };
			auditFlow(params).then(res => {
				if (res.data.code == 1) {
					this.list =  res.data.data
					this.title = '审核批注'
					this.edit = false
					this.ApprovalProcess = true;
				} else {
					this.$message.error(res.data.msg);
				}
			});
		},
		splc(e) {
			this.ApprovalProcess = false;
		},
		manuscriptrole() {
			manuscriptrole().then(res => {
				this.showsh = res.data.data;
				// this.Lengthofmotion();
			});
		},
		//新增印花税次报查询
		NewStampTax(){
			queryCompanyList().then(res=>{
				 if(res.data.code==1){
					this.StampTaxList = res.data.data
					this.secondaryReport = true
				}else{
					this.$message.error(res.data.msg)
				}
			})
		},
        //确认审核
        confirmationReview() {
            let newarr = this.tableData.filter(item => item.checked);
            let ids = newarr.map((item) =>  item.id );
            let params = {
                ids:ids
            }
            manuscriptconfirmTheReview(params).then(res => {
                if (res.data.code == 1) {
                    this.$message.success(res.data.msg);
                    this.manuscriptquery();
                } else {
                    this.$message.error(res.data.msg);
                }
            });
        },
		//新增印花税次报保存
		nextsecondary(){
			let list = this.$refs.tableboxyhs.getSelectionval()
			let companyNos = list.map(item=>{
				if(item.companyNo){
					return item.companyNo
				}
			})
			let params = {
				companyNos:companyNos.join(','),
				suosq:this.suosq,
			}
			addyhsTime(params).then(res=>{
				 if(res.data.code==1){
						this.secondaryReport = false
						this.manuscriptquery();
				}else{
					this.$message.error(res.data.msg)
				}
			})
		},
		//新增印花税次报删除
		yhsdelete(e){
			let params = {
				id:e.id
			}
			delete_yhsReport(params).then(res=>{
				 if(res.data.code=='1'){
					this.manuscriptquery();
				}else{
					this.$message.error(res.data.msg)
				}
			})
		},
		getShuizList() {
            queryCompanyShuibDict().then(res => {
				this.searchlist.forEach(item => {
					if (item.prop == 'shuizId') {
						item.selectval = res.data.data.map(item => {
							return {
								label: item.reportName,
								value: item.id
							};
						});
					}
				});
				let newarr = JSON.parse(JSON.stringify(this.searchlist));
				this.searchlist = newarr;
			});
		},
		forShengcdg() {
			let num = 0
			if (!this.tableData.filter(item => item.checked).length) {
				this.$message.error('请选择数据');
				return false;
			}
			try {
				this.tableData.forEach(item => {
					if (!['-1', '1', '0', '4','7'].includes(item.status) && item.checked) {
						this.$message.error('只有未填写、底稿、审核失败、草稿、申报失败状态可以生成底稿');
						throw Error();
					}
					if(item.checked&&item.sbbm=='yhs'&&item.jid== 0){
						num++
						if(num>1){
							this.$message.error('印花税暂不支持批量生成底稿');
							throw Error();
						}
					}
				});
			} catch (err) {
				throw err;
			}
			const companys = this.tableData
				.filter(item => item.checked)
				.map(gtem => {
					return {
						companyNo: gtem.companyNo,
						id: gtem.id,
						sbbm: gtem.sbbm,
						shuibId: gtem.shuibId,
						templateId: gtem.templateId
					};
				});
			let params = {
				companys: companys,
				suosq: this.suosq
			};
			forShengcdg(params).then(res => {
				if (res.data.code == 1) {
					this.manuscriptquery();
					this.$message.success(res.data.msg);
				} else {
					this.$message.error(res.data.msg);
				}
			});
		},
		submitAudit(arr) {
			if(!arr){
				if (!this.tableData.filter(item => item.checked).length) {
				this.$message.error('请选择数据');
				return false;
				}
				let isdg = false;
				let newarr = this.tableData.filter(item => item.checked);
				newarr.forEach(item => {
					if (item.status != '1') {
						isdg = true;
					}
				});
				if (isdg) {
					this.$message.error('只有底稿状态才可提交审核');
					return false;
				}
			}
			this.remark = ''
			this.remarkShow = true
			if(arr){
				this.idList = [arr.id]
			}else[
				this.idList = this.tableData.filter(item => item.checked).map(gtem => gtem.id)
			]

			// const companys = this.tableData.filter(item => item.checked).map(gtem => gtem.id);
			
		},
		nextremark(){
			let params = {
				reportIds:this.idList,
				remark:this.remark
			}
			submitAudit(params).then(res => {
				if (res.data.code == 1) {
					this.remarkShow = false
					this.manuscriptquery();
					this.$message.success(res.data.msg);
				} else {
					this.$message.error(res.data.msg);
				}
			});
		},
		manuscriptcancelAudit(arr) {
			this.$showConfirm({
	 		  message: "是否确定去掉审核?",
			  title:"取消审核",
	 		}).then((res) => {
	 		  if (res == "confirm") {
				  let params = [arr.id];
					manuscriptcancelAudit(params).then(res => {
						if (res.data.code == 1) {
							this.manuscriptquery();
							this.$message.success(res.data.msg);
						} else {
							this.$message.error(res.data.msg);
						}
			});
	 		  }else{
				   //取消
			  }
	 		});

		},
		submitAuditonly(arr) {
			if (arr.status != '1') {
				this.$message.error('只有底稿状态才可提交审核');
				return false;
			}
			let params = [arr.id];
			submitAudit(params).then(res => {
				if (res.data.code == 1) {
					this.manuscriptquery();
					this.$message.success(res.data.msg);
				} else {
					this.$message.error(res.data.msg);
				}
			});
		},
		manuscriptexport() {
			let exportIds = []
			this.tableData.map(item=>{
				if(item.checked){
					exportIds.push(item.id)
				}
			})
			let params = JSON.parse(JSON.stringify(this.searchdata));
			params.current = this.pagination.pageNum;
			params.size = this.pagination.pageSize;
			params.queryType = 1;
			params.suosq = this.suosq;
			if(exportIds.length>0){
				params.exportIds = exportIds
			}
			let newparams = {
				downUrl: config.baseURL + 'manuscript/manuscript/export',
				typeObj: {
					toForm: false,
					fileType: 'xlsx'
				},
				params: params
			};
			this.$downloadcommon(newparams);
		},
		fortosee(taxval) {
			this.mintext = '查看';
			this.detailtype = 'tosee';
			this.seeNow = true;
			this.Saleparams = taxval;
      this.showboxFun(taxval);
		},
		forupdate(taxval) {
			this.detailtype = 'update';
			this.mintext = '填写';
			this.seeNow = false;
			this.Saleparams = taxval;
      this.showboxFun(taxval);
		},
    showboxFun(taxval) {
      let version = this.templateDataMap[taxval.templateId].cank1;
      if (!version) {
        version = "";
      }
      this.showbox[taxval.sbbm + version] = true;
    },
		forback(e) {
			this.mintext = '查看';
			Object.keys(this.showbox).map(key => (this.showbox[key] = false));
			this.manuscriptquery();
		},
		//查询相关
		manuscriptquery() {
			let params = JSON.parse(JSON.stringify(this.searchdata));
			params.current = this.pagination.pageNum;
			params.size = this.pagination.pageSize;
			params.queryType = 1;
			params.suosq = this.suosq;
			manuscriptquery(params).then(res => {
				if (res.data.code == 1) {
					this.pagination.total = res.data.data.total;
					this.tableData = res.data.data.records;
					this.tableData.forEach(item => {
						item.checked = false;
					});
					this.checked = false;
					let newarr = JSON.parse(JSON.stringify(this.tableData));
					this.tableData = newarr;
					this.manuscriptrole();
					this.getShuizList();

				} else {
					this.$message.error(res.data.msg);
				}
			});
		},
		sizechange_risk(e){
			this.pagination_risk.pageSize = e;
		},
		currentChange_risk(e){
			this.pagination_risk.pageNum = e;
		},
		sizechange(e) {
			this.pagination.pageSize = e;
			this.manuscriptquery();
		},
		currentChange(e) {
			this.pagination.pageNum = e;
			this.manuscriptquery();
		},
		submitSearch() {
			this.pagination.pageNum = 1;
			this.pagination.paginationkey++;
			this.manuscriptquery();
		},
		suosqchange() {
			this.pagination.pageNum = 1;
			this.pagination.paginationkey++;
			this.manuscriptquery();
		},
		spanmethod({ row, column, rowIndex, columnIndex }) {
			if (columnIndex == 0 || columnIndex == 1) {
				return {
					rowspan: row.span > 0 ? row.span : 0,
					colspan: row.span > 0 ? 1 : 0
				};
			} else {
				return [1, 1];
			}
		},
		choosechange(e) {
			this.tableData.forEach(item => {
				item.checked = e;
			});
			let newarr = JSON.parse(JSON.stringify(this.tableData));
			this.tableData = newarr;
		},
		//上传附件
		openUpfileplus(id) {
			Object.keys(this.formdata).map(key => (this.formdata[key] = ''));
			Object.keys(this.upfile).map(key => (this.upfile[key] = ''));
			this.upfile.id = id;
			this.updiag = true;
		},
		closeupdiag() {
			this.updiag = false;
		},
		getuploadparams(e) {
			this.upfile.file=e.upfile
			this.upfile.fileName = e.upfilename;
			// manuscriptUploadFile({
			// 	file: e.upfile
			// }).then(res => {
			// 	if (res.data.code == 1) {
			// 		this.upfile.fileName = res.data.data.fileName;
			// 		this.upfile.fileUrl = res.data.data.fileUrl;
			// 	} else {
			// 		this.$message.error(res.data.msg);
			// 	}
			// });
		},
		forsubmit(e) {
			if (this.$emptyandnull(this.upfile.fileName)) {
				this.$message.error('请选择要上传的文件');
				return false;
			}
			let params = JSON.parse(JSON.stringify(this.formdata));
			// params.fileName = this.upfile.fileName;
			// params.fileUrl = this.upfile.fileUrl;
			params.file = this.upfile.file;
			params.id = this.upfile.id;
			annexadd(params).then(res => {
				if (res.data.code == 1) {
					this.manuscriptquery();
					this.closeupdiag();
				} else {
					this.$message.error(res.data.msg);
				}
			});
		},
		//文件查看
		sizechangefile() {
			this.paginationfile.pageSize = e;
		},
		currentChangefile() {
			this.paginationfile.pageNum = e;
		},
		forseefile(e) {
			this.chooseid = e.id;
			this.choosecompanyCode = e.companyCode;
			this.chooseshuibId = e.shuibId;
			let params = {
				id: e.id
			};
			params.current = this.paginationfile.pageNum;
			params.size = this.paginationfile.pageSize;
			queryAttachmentList(params).then(res => {
				this.tableseeData = res.data.data.records;
				this.paginationfile.total = res.data.data.total;
				this.toseediag = true;
			});
		},
		closetoseediag() {
			this.toseediag = false;
		},
		fordownloadFile(e) {
			let url = this.$winURl +e.fileUrl
			window.open(url)
			// fetch(url)
			// .then(res => res.blob())
			// .then(blob => {
			//     const a = document.createElement("a");
			//     const objectUrl = window.URL.createObjectURL(blob);
			//     a.download = e.fileName;
			//     a.href = objectUrl;
			//     a.click();
			//     window.URL.revokeObjectURL(objectUrl);
			//     a.remove();
			// })
			
			// let arr = e.fileName.split('.')
			// let params = {
			// 	downUrl: config.baseURL + 'manuscript/annex/downloads',
			// 	typeObj: {
			// 		toForm: false,
			// 		fileType: e.fileName.split('.')[arr.length-1],
			// 		fileName: e.fileName.split('.')[0],
			// 		failUrl:this.$winURl
			// 	},
			// 	params: {
			// 		attIds: [e.id],
			// 		companyCode: this.choosecompanyCode,
			// 		shuibId: this.chooseshuibId
			// 	}
			// };
			// this.$downloadcommon(params);
		},
		fordownloadpl(e) {
			if (this.$emptyandnull(e)) {
				this.$message.error('请选择要下载的数据');
				return false;
			}
			let params = {
				downUrl: config.baseURL + 'manuscript/annex/downloads',
				typeObj: {
					toForm: false,
					fileType: 'zip',
					failUrl:this.$winURl
				},
				params: {
					attIds: e.map(item => item.id),
					companyCode: this.choosecompanyCode,
					shuibId: this.chooseshuibId,

				}
			};
			this.$downloadcommon(params);
		},
		fodeleteFile(e) {
			this.$showConfirm({
				message: '确认删除?'
			}).then(res => {
				if (res == 'confirm') {
					annexdelete([e.id]).then(res => {
						if (res.data.code == 1) {
							this.$message.success('删除成功');
							this.paginationfile.paginationkey++;
							this.paginationfile.pageNum = '1';
							this.forseefile({
								id: this.chooseid,
								companyCode: this.choosecompanyCode,
								shuibId: this.chooseshuibId
							});
							this.manuscriptquery();
						} else {
							this.$message.error(res.data.msg);
						}
					});
				}
			});
		},
		//搜索和筛选
		forUpdateSearch() {
			this.searchdiag = true;
		},
		closeSearch() {
			this.searchdiag = false;
		},
		saveChange(e) {
			this.searchdiag = false;
		},
		confirmfilter(e) {
			this.headData = e.chooselist;
			this.outlist = e.nochooselist;
			this.shaidiag = false;
		},
		closeshaidiag() {
			this.shaidiag = false;
		},
    jzslsbqyChange() {
      this.manuscriptquery();
    }
	}
};
</script>

<style scoped lang="less">
@import url('./index.less');
</style>
